import {
  DEV,
  DEBUG_REFORMATTING_TEST_VIDEO,
  PUBLIC_MEDIA_BUCKET_PATH,
} from '../../../constants';
import { CHUNK_INDEX_TOKEN } from '../../frame-extraction/constants';
import { getThumbnailUrl } from '../../../util/mediaUtils';

export const createVRPublicMediaVariantUrl = (
  videoFile = DEBUG_REFORMATTING_TEST_VIDEO,
) => {
  const defaultVariance = 'file_chunkInterval=150_keyframeInterval=30';
  return `${PUBLIC_MEDIA_BUCKET_PATH}/${videoFile}/${defaultVariance}/${CHUNK_INDEX_TOKEN}.mp4`;
};

export const getVRPublicThumbnailUrl = (
  frameNumber,
  fileName = DEBUG_REFORMATTING_TEST_VIDEO,
) => {
  return `${PUBLIC_MEDIA_BUCKET_PATH}/${fileName}/frames/${frameNumber}.png`;
};

export const getEnvironmentSafeVRThumbnailUrl = (
  frameNumber,
  sourceMediaId,
  height = null,
  width = null,
) => {
  // We get thumbnail from public bucket since in local dev thumbnails are actually not generated
  return DEV
    ? getVRPublicThumbnailUrl(frameNumber, DEBUG_REFORMATTING_TEST_VIDEO)
    : getThumbnailUrl(sourceMediaId, {
        frameNumber,
        height,
        width,
      });
};
